import { render, staticRenderFns } from "./ModalNovaFormula.vue?vue&type=template&id=9caaf9d6&scoped=true"
import script from "./ModalNovaFormula.vue?vue&type=script&lang=js"
export * from "./ModalNovaFormula.vue?vue&type=script&lang=js"
import style0 from "./ModalNovaFormula.vue?vue&type=style&index=0&id=9caaf9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caaf9d6",
  null
  
)

export default component.exports